<template>
  <section class="overflow-hidden rounded-2xl bg-white shadow-sm ring-1 ring-gray-950/5 mb-16">
    <div class="border-b border-gray-100 px-6 py-4 sm:px-8">
      <h2 class="text-sm font-semibold text-gray-900">
        Historia zmian
      </h2>
      <p class="mt-1 text-sm text-gray-500">
        Kto i kiedy modyfikował ten rekord.
      </p>
    </div>

    <div class="overflow-x-auto">
      <table class="w-full min-w-[640px] text-left text-sm">
        <thead>
          <tr class="border-b border-gray-100 text-xs font-semibold uppercase tracking-wider text-gray-400">
            <th class="px-6 py-3 sm:px-8">
              Kiedy
            </th>
            <th class="px-6 py-3">
              Użytkownik
            </th>
            <th class="px-6 py-3">
              Akcja
            </th>
            <th class="px-6 py-3 sm:px-8">
              Zmiany
            </th>
          </tr>
        </thead>
        <tbody v-if="versions.length">
          <tr
            v-for="version in versions"
            :key="version.id"
            class="border-b border-gray-50 align-top last:border-b-0"
          >
            <td class="whitespace-nowrap px-6 py-4 text-gray-600 sm:px-8">
              {{ formatDate(version.created_at) }}
            </td>
            <td class="px-6 py-4">
              <div class="font-medium text-gray-900">
                {{ version.user_name || 'System / nieznany' }}
              </div>
              <div v-if="version.user_email" class="text-xs text-gray-500">
                {{ version.user_email }}
              </div>
            </td>
            <td class="whitespace-nowrap px-6 py-4 text-gray-700">
              {{ eventLabel(version.event) }}
            </td>
            <td class="px-6 py-4 sm:px-8">
              <ul v-if="version.changes?.length" class="space-y-2">
                <li
                  v-for="change in version.changes"
                  :key="`${version.id}-${change.attribute}`"
                  class="text-gray-700"
                >
                  <span class="font-medium text-gray-900">
                    {{ attributeLabel(change.attribute) }}
                  </span>
                  <div class="mt-0.5 font-mono text-xs leading-5 text-gray-500">
                    <span class="text-red-600/80">{{ displayValue(change.from) }}</span>
                    <span class="mx-1.5 text-gray-300">→</span>
                    <span class="text-emerald-700/90">{{ displayValue(change.to) }}</span>
                  </div>
                </li>
              </ul>
              <span v-else class="text-gray-400">—</span>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td class="px-6 py-8 text-gray-500 sm:px-8" colspan="4">
              Brak zapisanej historii zmian dla tego rekordu.
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script setup>
const ATTRIBUTE_LABELS = {
  title: 'Tytuł',
  excerpt: 'Zajawka',
  body_html: 'Treść',
  slug: 'Slug',
  status: 'Status',
  published_at: 'Data publikacji',
  site_context: 'Witryna',
  active: 'Aktywny',
  order: 'Kolejność',
  first_name: 'Imię',
  last_name: 'Nazwisko',
  description: 'Opis',
  remote_description: 'Opis (Medfile)',
  use_local_description: 'Używaj lokalnego opisu',
  important_information: 'Ważne informacje',
  treated_diseases: 'Leczone choroby',
  faq: 'FAQ',
  media: 'Media',
  name: 'Nazwa',
  remote_name: 'Nazwa (Medfile)',
  use_local_name: 'Używaj lokalnej nazwy',
  remote_id: 'Remote ID',
  category: 'Kategoria',
  price: 'Cena',
  duration: 'Czas trwania',
  button_text: 'Tekst przycisku',
  button_url: 'URL przycisku',
  button_link_label: 'Etykieta linku',
  button_link_type_label: 'Typ linku',
  show_button: 'Pokaż przycisk',
};

const EVENT_LABELS = {
  create: 'Utworzenie',
  update: 'Edycja',
  destroy: 'Usunięcie',
};

defineProps({
  versions: {
    type: Array,
    default: () => [],
  },
});

function formatDate(value) {
  if (!value) return '—';
  return new Date(value).toLocaleString('pl-PL', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

function eventLabel(event) {
  return EVENT_LABELS[event] || event || '—';
}

function attributeLabel(attribute) {
  return ATTRIBUTE_LABELS[attribute] || attribute;
}

function displayValue(value) {
  if (value == null || value === '') return '∅';
  return value;
}
</script>
